import React from 'react'
import "./deletePRNModal.css"
export const DeletePRNModal = ({ prn, wp, location, onClose, deletePRN }) => {

    const handleDeletePRN = () => {
        deletePRN()
        onClose()
    }

    return (
        <section className='delete-PRN-cont'>
            <h3>Are you sure you want to <br /> delete this PRN?</h3>
            <div className="delete-PRN-pCont">
                <p>PRN: <span>{prn}</span></p>
                <p>WP: <span>{wp}</span></p>
                {/* <p>Location: <span>{location}</span></p> */}

            </div>
            <div className='delete-PRN-btnCont'>
                <button onClick={handleDeletePRN}>Ok</button>
                <button onClick={onClose}>Cancel</button>
            </div>
        </section>
    )
}
